/*
    Если РПЛ - Selected_Well_IDs + InquiryID
    Всё остальное - WellID + InquiryID
*/

/*
    * Описание параметров:
        -- Selected_Well_IDs - ID скважины (идентично полю WellID). Передается, если исследования являются РПЛ.
        -- InquiryID - Ids исследований скважины
        -- WellID - ID скважины (идентично полю Selected_Well_IDs). Передается, если исследования НЕ являются РПЛ.
*/

const matches = {
    inquiryId: 'InquiryID',
    selectedWellId: 'Selected_Well_IDs',
    wellId: 'WellID',
};

/*
    TODO: доработать
*/
export const settingsGdiParams = (wellId, research) => {
    const { inquiryId, inquiryMethodId, methodShortName } = research;

    const inquiryIds = Array.isArray(inquiryId) ? inquiryId.join(',') : inquiryId;

    const result = {
        [matches.inquiryId]: inquiryIds,
    };

    if (inquiryMethodId === 1) {
        Object.assign(result, { [matches.selectedWellId]: wellId, [matches.wellId]: 0 });
    } else {
        Object.assign(result, { [matches.wellId]: wellId, [matches.selectedWellId]: 0 });
    }

    if (methodShortName) {
        result.GDI_TYPE = methodShortName;
    }

    return result;
};
